import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, Transition as _Transition, withCtx as _withCtx, Teleport as _Teleport } from "vue";
const _hoisted_1 = {
  class: "workspace-menu"
};
const _hoisted_2 = ["id", "disabled", "aria-expanded", "aria-label"];
const _hoisted_3 = {
  class: "workspace-trigger__name"
};
const _hoisted_4 = {
  class: "workspace-trigger__current"
};
const _hoisted_5 = {
  class: "workspace-account"
};
const _hoisted_6 = {
  class: "workspace-avatar"
};
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  key: 1
};
const _hoisted_9 = {
  class: "workspace-account__text"
};
const _hoisted_10 = {
  class: "workspace-grid"
};
const _hoisted_11 = ["disabled", "aria-current", "onClick"];
const _hoisted_12 = {
  class: "workspace-entry__text"
};
const _hoisted_13 = {
  key: 0,
  class: "workspace-current"
};
const _hoisted_14 = {
  class: "workspace-footer"
};
import { computed, nextTick, onBeforeUnmount, onMounted, ref, watch } from 'vue';
import { loadRouteLocation, useRoute, useRouter } from 'vue-router';
import { ElMessage } from 'element-plus';
import { Aim, ArrowDown, Grid, Location, Monitor, Setting, SwitchButton, User } from '@element-plus/icons-vue';
import { getUserInfo } from '@/api/requset/userLogin';
import { usePermissionList } from '@/common/hooks/usePermissionList';
import { hasPatrolManageAccess } from '@/newPages/patrol/composables/usePatrolAccess';
import { useDialogLaunch } from '@/common/hooks/useDialogLaunch';
import '@/assets/style/workspace-menu.scss';

// 账户展示由父组件覆盖；巡检布局可传入已有权限状态，避免重复请求。

export default {
  __name: 'WorkspaceMenu',
  props: {
    name: {
      type: String,
      default: ''
    },
    avatar: {
      type: String,
      default: ''
    },
    initials: {
      type: String,
      default: ''
    },
    triggerId: {
      type: String,
      default: ''
    },
    patrolAccess: {
      type: Boolean,
      default: undefined
    },
    showLogout: {
      type: Boolean,
      default: false
    }
  },
  emits: ['logout'],
  setup(__props, {
    emit: __emit
  }) {
    /** 值守、后台、巡检与布点共用的账户导航，负责权限显隐、路由切换与浮层交互。 */
    const props = __props;
    // 退出登录沿用宿主界面的原有流程。
    const emit = __emit;
    const route = useRoute();
    const router = useRouter();
    const {
      hasPermission
    } = usePermissionList();
    // 同一路由的预加载复用已有任务；失败后移除，允许下次打开菜单时重试。
    const routePreloads = new Map();
    const workspaces = [{
      id: 'sentry',
      path: '/home',
      label: '值守平台',
      description: '监测与告警',
      icon: Monitor
    }, {
      id: 'admin',
      path: '/ht',
      label: '后台管理',
      description: '项目与系统',
      icon: Setting
    }, {
      id: 'patrol',
      path: '/patrol',
      label: '巡检管理',
      description: '巡查与维修',
      icon: Location
    }, {
      id: 'points',
      path: '/devicePoints',
      label: '布点系统',
      description: '图纸与设备',
      icon: Aim
    }];
    // 本地账户用于无账户参数的工作台展示，解析失败时使用空账户。
    const cachedAccount = readCachedAccount();
    // 从服务端确认的巡检权限；加载失败时保持隐藏。
    const patrolAllowed = ref(false);
    // 触发按钮用于定位与关闭后的焦点恢复。
    const triggerRef = ref(null);
    // Teleport 菜单节点用于测量、外部点击判断和键盘导航。
    const menuRef = ref(null);
    // 头像加载失败时退回姓名首字母。
    const avatarFailed = ref(false);
    // 页面快照过渡期间阻止重复导航，原页面保持显示至目标路由就绪。
    const isSwitching = ref(false);
    // 显隐与点击锚点由项目浮层组合式函数统一管理。
    const {
      visible,
      launchPoint,
      open,
      close
    } = useDialogLaunch();
    // 浮层位置始终限制在当前视口中。
    const menuPosition = ref({
      left: 0,
      top: 0
    });
    // 账户信息优先采用宿主参数，其次使用当前登录缓存。
    const accountName = computed(() => props.name || cachedAccount.username || '未命名用户');
    // 账户头像缺省时显示姓名首字母。
    const accountAvatar = computed(() => props.avatar || cachedAccount.portrait || '');
    // 头像占位字符，沿用宿主提供的缩写。
    const accountInitials = computed(() => props.initials || accountName.value.charAt(0).toUpperCase());
    // 子路由同属一个工作台，首页两个地址均识别为值守平台。
    const currentWorkspace = computed(() => workspaces.find(item => route.path === item.path || route.path.startsWith(`${item.path}/`)) || workspaces[0]);
    // 入口权限与原值守菜单一致，巡检使用角色校验，布点使用项目导入权限。
    const visibleWorkspaces = computed(() => workspaces.filter(item => (item.id !== 'patrol' || (props.patrolAccess ?? patrolAllowed.value)) && (item.id !== 'points' || hasPermission('project:import'))));
    // 动画原点对应实际点击位置，兼容值守和布点页面的整体缩放。
    const menuStyle = computed(() => ({
      left: `${menuPosition.value.left}px`,
      top: `${menuPosition.value.top}px`,
      transformOrigin: `${launchPoint.value.x - menuPosition.value.left}px ${launchPoint.value.y - menuPosition.value.top}px`
    }));

    /**
     * 读取登录账户缓存，损坏的缓存不影响导航使用。
     * @returns 当前账户信息或空对象
     */
    function readCachedAccount() {
      try {
        const account = JSON.parse(localStorage.getItem('userInfo') || '{}');
        return account && typeof account === 'object' ? account : {};
      } catch {
        return {};
      }
    }

    /**
     * 打开或收回菜单，并根据实际按钮位置限制浮层边界。
     * @param {MouseEvent} event - 鼠标或键盘触发的点击事件
     */
    async function toggleMenu(event) {
      if (visible.value) {
        close();
        return;
      }
      const rect = triggerRef.value.getBoundingClientRect();
      const point = event.detail ? {
        x: event.clientX,
        y: event.clientY
      } : {
        x: rect.right,
        y: rect.bottom
      };
      open(point);
      await nextTick();
      if (!visible.value || !menuRef.value) return;
      updatePosition();
      menuRef.value.querySelector('[role="menuitem"]:not(:disabled)')?.focus();
      preloadWorkspaces();
    }

    /**
     * 预加载目标路由及其重定向后的默认子页面，不执行导航或挂载组件。
     * @param {string} path - 工作台入口路径
     * @returns {Promise<void>} 路由组件加载完成后结束
     */
    async function preloadRoute(path) {
      let target = router.resolve(path);
      const visited = new Set();
      let redirect = target.matched[target.matched.length - 1]?.redirect;
      while (redirect) {
        if (visited.has(target.fullPath)) throw new Error('工作台路由存在循环重定向');
        visited.add(target.fullPath);
        target = router.resolve(typeof redirect === 'function' ? redirect(target) : redirect);
        redirect = target.matched[target.matched.length - 1]?.redirect;
      }
      if (!routePreloads.has(target.fullPath)) {
        const preload = loadRouteLocation(target);
        routePreloads.set(target.fullPath, preload);
        preload.catch(() => routePreloads.delete(target.fullPath));
      }
      await routePreloads.get(target.fullPath);
    }

    /** 仅预加载菜单中有权限访问的其他工作台，失败不影响菜单和正常导航。 */
    function preloadWorkspaces() {
      for (const item of visibleWorkspaces.value) {
        if (item.id !== currentWorkspace.value.id) preloadRoute(item.path).catch(() => undefined);
      }
    }

    /** 按当前点击锚点和菜单高度重新定位，避免权限加载后浮层超出视口。 */
    function updatePosition() {
      if (!visible.value || !menuRef.value || !triggerRef.value) return;
      const rect = triggerRef.value.getBoundingClientRect();
      const menuRect = menuRef.value.getBoundingClientRect();
      menuPosition.value = {
        left: Math.max(16, Math.min(launchPoint.value.x - menuRect.width, window.innerWidth - menuRect.width - 16)),
        top: Math.max(16, Math.min(rect.bottom + 8, window.innerHeight - menuRect.height - 16))
      };
    }

    /**
     * 等待目标组件和导航守卫就绪后启动快照，保留旧页面并叠加淡入。
     * @param {string} path - 已配置的目标路由路径
     * @returns {Promise<void>} 页面切换和动画完成后结束
     */
    async function navigate(path) {
      if (isSwitching.value) return;
      close();
      triggerRef.value?.focus();
      if (route.path === path) return;
      const surface = document.getElementById('app');
      const root = document.documentElement;
      const shouldAnimate = typeof document.startViewTransition === 'function' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const previousInert = surface?.inert;
      const previousBusy = surface?.getAttribute('aria-busy');
      const previousTransition = root.getAttribute('data-workspace-transition');
      const startingRoute = router.currentRoute.value;
      const target = router.resolve(path);
      let navigation;
      let transition;
      let transitionDone;
      let removeResolveGuard;
      /**
       * 恢复已加载的导航并等待 DOM 更新，不在快照阶段等待组件下载。
       * @param {Function} resume - 允许当前导航守卫继续执行
       * @returns {Promise<void>} 目标页面 DOM 更新后结束
       */
      const update = async resume => {
        resume();
        const failure = await navigation;
        if (failure) transition.skipTransition();
        await nextTick();
      };
      /**
       * 在本次导航的最终页面加载完成后启动快照，其他导航继续沿用原有流程。
       * @param {import('vue-router').RouteLocationNormalized} to - 守卫或配置重定向后的目标
       * @param {import('vue-router').RouteLocationNormalized} from - 当前导航的来源
       * @returns {Promise<void>|undefined} 快照捕获旧页面后放行本次导航
       */
      const beginTransition = (to, from) => {
        if (from !== startingRoute || to.fullPath !== target.fullPath && to.redirectedFrom?.fullPath !== target.fullPath) {
          return;
        }
        removeResolveGuard();
        return new Promise(resolve => {
          root.setAttribute('data-workspace-transition', 'fade');
          transition = document.startViewTransition(() => update(resolve));
          // 动画被跳过或更新失败时仍接收所有拒绝，避免导航失败后产生未捕获错误。
          transition.ready.catch(() => undefined);
          transitionDone = Promise.all([transition.updateCallbackDone, transition.finished]);
          transitionDone.catch(() => undefined);
        });
      };
      isSwitching.value = true;
      try {
        if (surface) {
          surface.inert = true;
          surface.setAttribute('aria-busy', 'true');
        }
        if (shouldAnimate) {
          // beforeResolve 在懒加载和已有守卫之后执行，慢加载期间旧页面仍可正常渲染。
          removeResolveGuard = router.beforeResolve(beginTransition);
        }
        navigation = router.push(path);
        await navigation;
        await nextTick();
        await transitionDone;
      } catch {
        transition?.skipTransition();
        await transitionDone?.catch(() => undefined);
        ElMessage.error('工作台切换失败，请重试');
      } finally {
        removeResolveGuard?.();
        if (previousTransition === null) root.removeAttribute('data-workspace-transition');else root.setAttribute('data-workspace-transition', previousTransition);
        if (surface) {
          surface.inert = previousInert;
          if (previousBusy === null) surface.removeAttribute('aria-busy');else surface.setAttribute('aria-busy', previousBusy);
        }
        isSwitching.value = false;
      }
    }

    /**
     * 只允许跳转至当前可见的其他工作台。
     * @param {string} id - 工作台标识
     */
    function selectWorkspace(id) {
      const target = visibleWorkspaces.value.find(item => item.id === id);
      if (target && target.id !== currentWorkspace.value.id) navigate(target.path);
    }

    /** 收回菜单并由宿主执行原有退出登录流程。 */
    function logout() {
      close();
      triggerRef.value?.focus();
      emit('logout');
    }

    /**
     * 外部点击时收回菜单。
     * @param {PointerEvent} event - 页面指针事件
     */
    function handleOutsideClick(event) {
      if (!triggerRef.value?.contains(event.target) && !menuRef.value?.contains(event.target)) close();
    }

    /**
     * 页面滚动时关闭菜单，菜单内部滚动继续保持展开。
     * @param {Event} event - 捕获的滚动事件
     */
    function handleScroll(event) {
      if (!menuRef.value?.contains(event.target)) close();
    }

    /**
     * 支持关闭、上下循环与首尾菜单项的键盘导航。
     * @param {KeyboardEvent} event - 页面键盘事件
     */
    function handleKeydown(event) {
      if (!visible.value) return;
      if (event.key === 'Escape') {
        close();
        triggerRef.value?.focus();
      } else if (event.key === 'Tab') {
        close();
      } else if (['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) {
        event.preventDefault();
        const buttons = Array.from(menuRef.value?.querySelectorAll('[role="menuitem"]:not(:disabled)') || []);
        if (!buttons.length) return;
        const current = buttons.indexOf(document.activeElement);
        let next = 0;
        if (event.key === 'End') next = buttons.length - 1;else if (event.key === 'ArrowUp') next = current > 0 ? current - 1 : buttons.length - 1;else if (event.key === 'ArrowDown') next = (current + 1) % buttons.length;
        buttons[next].focus();
      }
    }
    watch(() => route.fullPath, close);
    watch(accountAvatar, () => {
      avatarFailed.value = false;
    });
    watch(visibleWorkspaces, async () => {
      if (visible.value) preloadWorkspaces();
      await nextTick();
      updatePosition();
    });
    onMounted(async () => {
      document.addEventListener('pointerdown', handleOutsideClick);
      document.addEventListener('keydown', handleKeydown);
      window.addEventListener('scroll', handleScroll, true);
      window.addEventListener('resize', close);
      if (props.patrolAccess === undefined) {
        try {
          const response = await getUserInfo();
          patrolAllowed.value = hasPatrolManageAccess(response?.data?.roleNames);
        } catch {
          patrolAllowed.value = false;
        }
      }
    });
    onBeforeUnmount(() => {
      close();
      document.removeEventListener('pointerdown', handleOutsideClick);
      document.removeEventListener('keydown', handleKeydown);
      window.removeEventListener('scroll', handleScroll, true);
      window.removeEventListener('resize', close);
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("button", {
        id: __props.triggerId || undefined,
        ref_key: "triggerRef",
        ref: triggerRef,
        class: "workspace-trigger",
        type: "button",
        disabled: isSwitching.value,
        "aria-haspopup": "menu",
        "aria-expanded": _unref(visible),
        "aria-label": `${accountName.value}，切换工作台`,
        onClick: toggleMenu
      }, [_createVNode(_unref(Grid), {
        class: "workspace-trigger__icon"
      }), _createElementVNode("span", _hoisted_3, _toDisplayString(accountName.value), 1), _createElementVNode("span", _hoisted_4, _toDisplayString(currentWorkspace.value.label), 1), _createVNode(_unref(ArrowDown), {
        class: _normalizeClass(["workspace-trigger__arrow", {
          'is-open': _unref(visible)
        }])
      }, null, 8, ["class"])], 8, _hoisted_2), (_openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [_createVNode(_Transition, {
        name: "workspace-menu"
      }, {
        default: _withCtx(() => [_unref(visible) ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          ref_key: "menuRef",
          ref: menuRef,
          class: "workspace-panel",
          style: _normalizeStyle(menuStyle.value),
          role: "menu",
          "aria-label": "账户与工作台切换"
        }, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [accountAvatar.value && !avatarFailed.value ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: accountAvatar.value,
          alt: "",
          onError: _cache[0] || (_cache[0] = $event => avatarFailed.value = true)
        }, null, 40, _hoisted_7)) : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(accountInitials.value), 1))]), _createElementVNode("div", _hoisted_9, [_createElementVNode("strong", null, _toDisplayString(accountName.value), 1), _cache[2] || (_cache[2] = _createElementVNode("span", null, "智慧消防 · 工作台导航", -1))])]), _cache[5] || (_cache[5] = _createElementVNode("div", {
          class: "workspace-caption"
        }, "切换工作台", -1)), _createElementVNode("div", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleWorkspaces.value, item => {
          return _openBlock(), _createElementBlock("button", {
            key: item.id,
            class: _normalizeClass(["workspace-entry", {
              'is-current': item.id === currentWorkspace.value.id
            }]),
            type: "button",
            role: "menuitem",
            disabled: item.id === currentWorkspace.value.id,
            "aria-current": item.id === currentWorkspace.value.id ? 'page' : undefined,
            onClick: $event => selectWorkspace(item.id)
          }, [(_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), {
            class: "workspace-entry__icon"
          })), _createElementVNode("span", _hoisted_12, [_createElementVNode("strong", null, _toDisplayString(item.label), 1), _createElementVNode("span", null, _toDisplayString(item.description), 1)]), item.id === currentWorkspace.value.id ? (_openBlock(), _createElementBlock("span", _hoisted_13, "当前")) : _createCommentVNode("", true)], 10, _hoisted_11);
        }), 128))]), _createElementVNode("div", _hoisted_14, [_createElementVNode("button", {
          type: "button",
          role: "menuitem",
          onClick: _cache[1] || (_cache[1] = $event => navigate('/ht/userInfo'))
        }, [_createVNode(_unref(User)), _cache[3] || (_cache[3] = _createTextVNode("个人信息 "))]), __props.showLogout ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "workspace-logout",
          type: "button",
          role: "menuitem",
          onClick: logout
        }, [_createVNode(_unref(SwitchButton)), _cache[4] || (_cache[4] = _createTextVNode("退出登录 "))])) : _createCommentVNode("", true)])], 4)) : _createCommentVNode("", true)]),
        _: 1
      })]))]);
    };
  }
};